import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 14l4 -4l-4 -4","key":"svg-0"}],["path",{"d":"M19 10h-11a4 4 0 1 0 0 8h1","key":"svg-1"}]]

/**
 * IconArrowForwardUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZm9yd2FyZC11cCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTUgMTRsNCAtNGwtNCAtNCIgLz4KICA8cGF0aCBkPSJNMTkgMTBoLTExYTQgNCAwIDEgMCAwIDhoMSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-forward-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowForwardUp = createReactComponent('outline', 'arrow-forward-up', 'ArrowForwardUp', __iconNode);

export default IconArrowForwardUp;